import { type ReactNode } from "react";
import { BackArrowIcon } from "vega-icons";

import { ThemedButton } from "../ThemedButton";
import {
  ThemedIconButton,
  type ThemedIconButtonProps,
} from "../ThemedIconButton";

type Props = Pick<ThemedIconButtonProps, "disabled" | "onClick"> & {
  children?: ReactNode;
};

export const BackButton = ({ children, ...props }: Props) => {
  if (children) {
    return (
      <ThemedButton
        ariaLabel="Back"
        dataTestId="back-button"
        icon={<BackArrowIcon />}
        variant="text"
        {...props}
      >
        {children}
      </ThemedButton>
    );
  }

  return (
    <ThemedIconButton
      ariaLabel="Back"
      dataTestId="back-button"
      icon={<BackArrowIcon />}
      variant="noBackground"
      {...props}
    />
  );
};
